export default __webpack_public_path__ + "static/media/slide6.3540190a.png";